const monthsShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const Dater = {
    format: (date, format = 'M d, Y') =>
    {
        const initDate = new Date(date);
        let getDate = initDate.getDate();
        const getMonth = initDate.getMonth();
        const getYear = initDate.getFullYear();
        
        if (getDate <= 9) getDate = `0${getDate}`;

        switch (format)
        {
            case 'M d, Y':
            {
                return `${monthsShort[getMonth]} ${getDate}, ${getYear}`;
            }

            case 'F d, Y':
            {
                return `${monthsFull[getMonth]} ${getDate}, ${getYear}`;
            }

            case 'jS F Y':
            {
                let jS = '';

                const arrayOfDate = Array.from(String(getDate), Number);

                if (arrayOfDate.length === 1 && getDate === 1) jS = `${getDate}st day of`;
                else if (arrayOfDate.length === 1 && getDate === 2) jS = `${getDate}nd day of`;
                else if (arrayOfDate.length === 1 && getDate === 3) jS = `${getDate}rd day of`;
                else if (arrayOfDate.length === 1 && getDate > 3) jS = `${getDate}st day of`;
                else if (arrayOfDate.length > 1 && arrayOfDate[0] === 1) jS = `${getDate}th day of`;
                else if (arrayOfDate.length > 1 && arrayOfDate[0] > 1 && arrayOfDate[1] === 1) jS = `${getDate}st day of`;
                else if (arrayOfDate.length > 1 && arrayOfDate[0] > 1 && arrayOfDate[1] === 2) jS = `${getDate}nd day of`;
                else if (arrayOfDate.length > 1 && arrayOfDate[0] > 1 && arrayOfDate[1] === 3) jS = `${getDate}rd day of`;
                else if (arrayOfDate.length > 1 && arrayOfDate[0] > 1 && arrayOfDate[1] > 3) jS = `${getDate}th day of`;

                return `${jS} ${monthsFull[getMonth]}, ${getYear}`;
            }

            case 'd-m-Y':
            {
                return `${getDate}-${monthsShort[getMonth].toUpperCase()}-${getYear}`;
            }

            case 'yyyy-mm-dd':
            {
                let newMonth = getMonth + 1;
                if (newMonth <= 9) newMonth = `0${newMonth}`;
                return `${getYear}-${newMonth}-${getDate}`;
            }

            default:
            {
                return `${monthsShort[getMonth]} ${getDate}, ${getYear}`;
            }
        }
    },

    weekToday: () =>
    {
        const target = new Date();

        const dayNr = (target.getDay() + 6) % 7;

        target.setDate((target.getDate() - dayNr) + 3);

        const firstThursday = target.valueOf();

        target.setMonth(0, 1);

        if (target.getDay() !== 4)
        {
            target.setMonth(0, (1 + ((4 - target.getDay()) + 7)) % 7);
        }

        return 1 + Math.ceil((firstThursday - target) / 604800000);
    },

    rawToday: () =>
    {
        const today = new Date();
        const fullYear = today.getFullYear();
        const month = ((today.getMonth() + 1) < 10 ? `0${(today.getMonth() + 1)}` : (today.getMonth() + 1));
        const date = ((today.getDate()).length < 10 ? `0${(today.getDate())}` : (today.getDate()));

        return `${fullYear}-${month}-${date}`;
    },

    secToDays: (seconds) =>
    {
        return Math.floor(Number(seconds) / (3600*24));
    },

    age: (date) =>
    {
        const today = new Date();
        var birthDate = new Date(date);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    },

    trim: (date) =>
    {
        if (date.length > 9)
        {
            return date.substr(0,10);
        }

        return date;
    },
};



// WEBPACK FOOTER //
// ./src/utils/date.js